import type { IRestEndpointConfig } from '@deity-io/di-data-flows';
import React from 'react';

export enum WebServiceActionTypes {
  INIT_WEB_SERVICE_CONFIG = 'INIT_WEB_SERVICE_CONFIG',
  SET_VALUE = 'SET_VALUE',
  UNSET_VALUE = 'UNSET_VALUE',
  SET_PROPERTY = 'SET_PROPERTY',
  UNSET_PROPERTY = 'UNSET_PROPERTY'
}

export interface ISetValuePayload {
  key: string[];
  value: any;
}

export interface IInitWebServiceConfig {
  type: WebServiceActionTypes.INIT_WEB_SERVICE_CONFIG;
  payload: {
    uuid: string;
    packageVersionUuid: string;
    name: string;
    description?: string;
    schema: Partial<IRestEndpointConfig>;
  };
}

export interface ISetValue {
  type: WebServiceActionTypes.SET_VALUE;
  payload: ISetValuePayload;
}

export interface IUnsetValue {
  type: WebServiceActionTypes.UNSET_VALUE;
  payload: { key: string[] };
}

export interface ISetProperty {
  type: WebServiceActionTypes.SET_PROPERTY;
  payload: Array<{
    key: string[];
    value: any;
  }>;
}

export interface IUnsetProperty {
  type: WebServiceActionTypes.UNSET_PROPERTY;
  payload: { keys: Array<string[]> };
}

export type WebServiceActions = IInitWebServiceConfig | ISetValue | IUnsetValue | ISetProperty | IUnsetProperty;

export interface IWebServiceConfigState {
  uuid?: string;
  packageVersionUuid?: string;
  name?: string;
  description?: string;
  schema: Partial<IRestEndpointConfig>;
}

export interface WebServiceContextInterface {
  state: IWebServiceConfigState;
  dispatch: (webServiceActions: WebServiceActions) => void;
}
export const WebServiceContext = React.createContext<WebServiceContextInterface | null>(null);
